module.exports = __webpack_public_path__ + "img/addIdentity.8cbf17ee.jpg";